import React from 'react';
import { Box, Typography, Button, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { styled } from '@mui/system';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import whatsAppGateway from './img/whatsappGatewayImg.png';

// Custom styled components for better design
const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
  backgroundColor: '#f2faf6',
  minHeight: '100vh',
  maxWidth: '1200px',
  margin: '0 auto',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
}));

const LeftSection = styled(Box)(({ theme }) => ({
  flex: 1,
  paddingRight: theme.spacing(3),
  paddingLeft: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    paddingRight: 0,
    paddingLeft: 0,
    marginBottom: theme.spacing(3),
    textAlign: 'center',
  },
}));

const RightSection = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    paddingLeft: 0,
    paddingRight: 0,
    width: '100%',
  },
}));

const Headline = styled(Typography)(({ theme }) => ({
  fontSize: '3rem',
  fontWeight: 800,
  color: '#1a1a1a',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    fontSize: '2rem',
    fontWeight: 800,
  },
}));

const HighlightText = styled('span')({
  color: '#00c853',
});

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#00c853',
  color: '#fff',
  padding: theme.spacing(1, 3),
  fontWeight: 600,
  borderRadius: '15px',
  marginTop: theme.spacing(3),
  marginLeft: theme.spacing(2),
  '&:hover': {
    backgroundColor: '#00b046',
  },
  [theme.breakpoints.down('md')]: {
    marginLeft: 0,
  },
}));

const WhatsAppAdd_Gateway = () => {
  return (
    <Container>
      {/* Left Section: Text Content */}
      <LeftSection>
        <Headline>
          YOUR GATEWAY TO 5X <br />
          <HighlightText>REVENUE</HighlightText>
        </Headline>

        {/* Image shown after title on small devices */}
        <Box
          sx={{
            display: { xs: 'block', md: 'none' },
            marginBottom: '24px', // Replaced theme.spacing(3) with static value (3 * 8 = 24px)
            marginTop: '24px',
          }}
        >
          <Box
            component="img"
            src={whatsAppGateway}
            alt="Smartphone with Ad and Chat"
            sx={{
              width: { xs: '350px', md: '500px' },
              height: 'auto',
              maxWidth: '100%',
            }}
          />
        </Box>

        <List>
          <ListItem>
            <ListItemIcon>
              <TouchAppIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="One-Click Lead Generation"
              secondary="Get user's name & WhatsApp number as soon as they click your ad."
              primaryTypographyProps={{ fontSize: { xs: '1.1rem', md: '1.2rem' } }}
              secondaryTypographyProps={{ fontSize: { xs: '0.9rem', md: '1rem' } }}
            />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <SmartToyIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="AI Ad Campaign Manager"
              secondary="Target better audiences with the power of AI, drive 3-5X more conversions."
              primaryTypographyProps={{ fontSize: { xs: '1.1rem', md: '1.2rem' } }}
              secondaryTypographyProps={{ fontSize: { xs: '0.9rem', md: '1rem' } }}
            />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <CurrencyExchangeIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Engage with Personalized Broadcasts"
              secondary="Segment acquired leads in AISensy CRM & send personalized broadcast campaigns."
              primaryTypographyProps={{ fontSize: { xs: '1.1rem', md: '1.2rem' } }}
              secondaryTypographyProps={{ fontSize: { xs: '0.9rem', md: '1rem' } }}
            />
          </ListItem>
        </List>

        <StyledButton variant="contained" endIcon={<ArrowForwardIcon />}>
          GET 500 FREE CREDITS
        </StyledButton>
      </LeftSection>

      {/* Right Section: Image for medium and larger devices */}
      <RightSection sx={{ display: { xs: 'none', md: 'flex' } }}>
        <Box
          component="img"
          src={whatsAppGateway}
          alt="Smartphone with Ad and Chat"
          sx={{
            width: { xs: '350px', md: '500px' },
            height: 'auto',
            maxWidth: '100%',
          }}
        />
      </RightSection>
    </Container>
  );
};

export default WhatsAppAdd_Gateway;